import React, { useState } from 'react'
import Collapse from '@kunukn/react-collapse'

const HelpItem = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <React.Fragment>
      <div onClick={() => setIsOpen(!isOpen)} className='col-12 border-color-ui-3 bg-white border px-2 py-3'>
        <p>
          <strong>Perdi ou roubaram o meu cartão</strong>
        </p>
      </div>
      <Collapse
        isOpen={isOpen}
        className={'app__collapse app__collapse--gradient ' + (isOpen ? 'app__collapse--active' : '')}
        transition='height 800ms cubic-bezier(0.4, 0, 0.2, 1)'
        aria-hidden={isOpen ? 'false' : 'true'}
        elementType='article'
        render={collapseState => (
          <React.Fragment>
            <div className='bg-ui-4 border-color-ui-3 border p-2'>
              <p className='mb-2'>
                    Sentimos muito que isso tenha acontecido!
              </p>
              <p className='mb-2'>
                    Mas não se preocupe:
              </p>
              <ul>
                <li className='mb-2'>
                        Se você o perdeu, pode bloqueá-lo para garantir que ninguém o use até que você o encontre.
                </li>
                <li className='mb-2'>
                        Se o cartão não foi encontrado, foi roubado ou está danificado, informe o ocorrido e peça um novo.
                </li>
              </ul>

              <p className='mb-2'>
                    Acesse aqui para bloquear seu cartão ou pedir um novo
              </p>

              <p className='mb-2'>
                    Essa informação foi útil?
              </p>
              <div className='d-flex'>
                <button className='like-button mr-2'>
                  <div className='icon icon_like' />
                </button>

                <button className='like-button'>
                  <div className='icon icon_dislike' />
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      />
    </React.Fragment>
  )
}

export default HelpItem



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/Help/HelpItem.js